<template>
  <img
    v-bind="$attrs"
    v-lazy="source"
    :style="style"
  />
</template>

<script>
export default {
  props: {
    src: [String, File],
    placeholder: String,
    isBackground: Boolean,
    waitLoad: Boolean,
  },
  data () {
    return {
      virtual: null,
      isLoaded: false,
      isReady: false
    }
  },
  computed: {
    source () {
      const isPlaceholder = this.placeholder && !this.isLoaded
      const source = isPlaceholder
        ? (!this.waitLoad || this.isReady) && this.placeholder
        : this.src
      return source
    },
    style () {
      const isEmpty = !this.isBackground || !this.source
      const style = isEmpty ? {} : { 'background-image': `url(${this.source})` }
      return style
    }
  },
  watch: {
    src () {
      this.isLoaded = false
      this.createVirtualImage()
    }
  },
  methods: {
    load () {
      this.isLoaded = this.isReady = true
    },

    error () {
      this.isReady = true
    },

    createVirtualImage () {
      if (this.virtual)
        this.destroyVirtualImage()

      this.virtual = new Image()

      this.virtual.addEventListener('load', this.load)
      this.virtual.addEventListener('error', this.error)

      this.virtual.src = this.src
    },

    destroyVirtualImage () {
      if (!this.virtual)
        return

      this.virtual.removeEventListener('load', this.load)
      this.virtual.removeEventListener('error', this.error)

      this.virtual = null
    }
  },

  beforeDestroy () {
    if (!this.placeholder)
      return

    this.destroyVirtualImage()
  },

  mounted () {
    if (!this.placeholder)
      return

    this.createVirtualImage()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CComponents/CImage.vue